module.exports = __webpack_public_path__ + "img/rg.7818bd5d.png";